import EventModel from '@/models/list/event';

export default {
  name: 'eventConstructor',
  namespaced: true,
  state: {
    event: null,
  },
  getters: {
    getEvent: (state) => state.event,
  },
  actions: {
    setEvent({ commit }, data) {
      const eventModel = data && !(data instanceof EventModel)
        ? new EventModel(data, 'events')
        : data;
      commit('SET_EVENT', eventModel);
    },
  },
  mutations: {
    SET_EVENT(state, data) {
      state.event = data;
    },
  },
};
